import { ColorSelectorUtil, SelectedColor } from "@mcleod/common";
import { AutogenLayoutAppointmentStatus } from "./autogen/AutogenLayoutAppointmentStatus";

export class AppointmentStatus extends AutogenLayoutAppointmentStatus {
    override onLoad() {
        this.mainDataSource.orderBy = [{field: "descr", sort: "asc" }];
    }

    sourceAppointmentStatusAfterExecution() {
        this.panelColorDisplay.backgroundColor = this.mainDataSource?.activeRow?.get("status_hex_color");
        this.panelColorDisplay.tooltip = this.mainDataSource?.activeRow?.get("status_hex_color");
    }

    buttonClearColorOnClick() {
        this.syncStatusColor({});
    }

    async buttonColorPickerOnClick() {
        const result = await ColorSelectorUtil.promptForNumericColor();
        if (result?.hexColor && result?.numericColor) {
            this.syncStatusColor(result);
        }
    }

    private syncStatusColor(result: SelectedColor = {}) {
        const { colorName, hexColor, numericColor } = result;
        this.sourceAppointmentStatus.activeRow.set("status_hex_color", hexColor);
        this.sourceAppointmentStatus.activeRow.set("status_color", numericColor);
        this.panelColorDisplay.backgroundColor = colorName;
        this.panelColorDisplay.tooltip = hexColor;
    }
}
